export const dict = {
    Position: "position",
    OddsTab: "player odds"
};
//# sourceMappingURL=dict.js.map